import { createAction } from '@reduxjs/toolkit';

import { SET_DEAD_END_FOR_CLAIM_GROUP } from '../actionTypes/claimDeadEnd';

export const setDeadEndForClaimGroup = createAction<{
  orderId?: string;
  message: any;
  groupId: any;
  claimIds?: string[];
}>(SET_DEAD_END_FOR_CLAIM_GROUP.BASE);
